import { isIOS } from 'react-device-detect';

import canPlayInBrowser from './canPlayInBrowser';

let revokeRegistry: FinalizationRegistry<string> | null = null;

// workaround for prerendering
if (typeof window === 'object' && window?.FinalizationRegistry) {
  revokeRegistry = new FinalizationRegistry<string>((heldValue) => {
    URL.revokeObjectURL(heldValue);
  });
}

async function getLocalPreview(file: File): Promise<string | null> {
  if (isIOS) {
    return null;
  }

  if (await canPlayInBrowser(file)) {
    const url = URL.createObjectURL(file);

    revokeRegistry?.register(file, url);

    return url;
  }

  return null;
}

export default getLocalPreview;
